import {httpMonitorAPI} from 'features/http';
import {summaryHomeAPI} from 'entities/monitor';
import {getPollingInterval} from 'shared/api/pollingHelper';

export const useDashboard = () => {
    const {
        data: summaryMonitors,
        isLoading: isLoadingMonitors,
        isFetching: isFetchingMonitors,
    } = httpMonitorAPI.useGetSummaryHttpMonitorsQuery(undefined, {
        pollingInterval: getPollingInterval(),
    });

    const {data: home} = summaryHomeAPI.useGetSummaryHomeQuery(undefined, {
        pollingInterval: getPollingInterval(),
    });

    return {
        summaryMonitors,
        isLoadingMonitors,
        isFetchingMonitors,
        home,
    };
};
